import React from "react";
import "./Services.css";
import WeatherApp from "../../components/WeatherApp";

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <div className="hero-banner">
        <h1 className="hero-title">SERVICES</h1>
        <p className="breadcrumb">
          <a
            href="/"
            style={{
              color: "inherit",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Home
          </a>{" "}
          /
          <a
            href="/service"
            style={{
              color: "inherit",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Services
          </a>
        </p>
      </div>

      {/* Our Services Section */}
      <section className="section services">
        <h2 className="section-subtitle">Farmology</h2>
        <h1 className="section-title">Our Services</h1>
        <div className="services-grid">
          <div className="service-card crop-clinic">
            <div className="service-card-content">
              <h3 className="service-title">CROP CLINIC</h3>
              <p className="service-description">
                Instantly diagnose your crop condition through machine learning.
              </p>
            </div>
          </div>
          <div className="service-card soil-health">
            <div className="service-card-content">
              <h3 className="service-title">SOIL HEALTH</h3>
              <p className="service-description">
                Get super quick and accurate soil health reports with our IoT
                technology.
              </p>
            </div>
          </div>
          <div className="service-card crop-health">
            <div className="service-card-content">
              <h3 className="service-title">CROP HEALTH</h3>
              <p className="service-description">
                Monitor your crops remotely to achieve the best production.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Farming Solutions Section */}
      <section className="section farming-solutions">
        <h2 className="section-subtitle">Farmology Services</h2>
        <h1 className="section-title">Our Farming Solutions</h1>
        <div className="solutions-grid">
          <div className="solution-card">
            <h3>AGRI-INPUT</h3>
            <p>
              Sustainable Agri-inputs for soil quality and higher yield with
              cost-effectiveness.
            </p>
          </div>
          <div className="solution-card ">
            <h3>CONSULTATION</h3>
            <p>
              A mobile platform for farmers to identify crop-related problems &
              get unbiased solutions.
            </p>
          </div>
          <div className="solution-card ">
            <h3>CROP HEALTH</h3>
            <p>
              Detailed crop health reports in regional languages for precise
              advisory.
            </p>
          </div>
          <div className="solution-card market-access">
            <h3>MARKET ACCESS</h3>
            <p>
              Enables farmers to sell their yield at better prices, eliminating
              intermediaries.
            </p>
          </div>
        </div>
      </section>

      {/* Weather App Section */}
      <section className="section weather-section">
        <h1 className="section-title">Weather Information</h1>
        <WeatherApp />
      </section>
    </div>
  );
};

export default Services;
